export default __webpack_public_path__ + "navigation-examples-route-deserialize-thumbnail-960-f8bcaa89447a00b54f9e1a228884a113.png";